/**
 * @file 加载组件
 * @author mengchen <mengchen@babytree-inc.com>
 */
import React, { Fragment } from 'react';
import Mask from '../Mask';
import './index.scss';

export const Loading = React.forwardRef(
    ({ loading = true, message = '', className = '', mask = true }, ref) => {
        return (
            <Fragment>
                {mask ? <Mask backgroundColor="transparent" /> : null}
                <div
                    id="component-loading"
                    className={`${className} ${
                        loading ? 'component-loading-in' : 'component-loading-out'
                    }`}
                    ref={ref}
                >
                    <div className="g-bbt-loading-logo component-loading-main"></div>
                    {message ? (
                        <p className="component-loading-message">{message}</p>
                    ) : null}
                </div>
            </Fragment>
        );
    }
);

export const Loading2 = React.forwardRef(
    ({ loading = true, message = '', className = '', mask = true }, ref) => {
        return (
            <Fragment>
                {mask ? <Mask backgroundColor="transparent" /> : null}
                <div
                    id="component-loading2"
                    className={`${className} ${
                        loading ? 'component-loading-in' : 'component-loading-out'
                    }`}
                    ref={ref}
                >
                    <div className="component-loading-main">
                        <svg
                            className="component-loading-icon"
                            viewBox="0 0 100 100"
                            version="1.1"
                        >
                            <circle
                                className="component-loading-circle"
                                cx="50"
                                cy="50"
                                r="44"
                                transform="rotate(90 50 50)"
                                strokeDasharray="207.34511513692632 276.46015351590177"
                            />
                        </svg>
                        {message ? (
                            <p className="component-loading-message">{message}</p>
                        ) : null}
                    </div>
                </div>
            </Fragment>
        );
    }
);

export const LoadingMask = ({ loading = true }) => {
    if (!loading) return null;
    return (
        <div id="component-loading-mask" className="g-bbt-loading">
            <div className="g-bbt-loading-main">
                <div className="g-bbt-loading-logo"></div>
                <div className="g-bbt-loading-tip">
                    努力加载中<i className="g-bbt-loading-tip-dots">...</i>
                </div>
            </div>
        </div>
    );
};

export const LoadingBar = ({ loading = true }) => (
    <div id="component-loading-bar">
        <div className={`loading${loading ? ' active' : ''}`} />
    </div>
);

export const Waiting = () => (
    <div id="component-waiting">
        <span />
    </div>
);
